import definition from './config.service';

/**
 * ConfigApi settings
 * @type {{name: string, definition: ConfigApi}}
 */
export default {
    name: 'ConfigApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/config/index.js